import { utils } from '@sfaas/util';
import client from '@/api/client';
import { BASE_URL } from '@/constants';

export default {
	getSqlIds: ({ urlSearchParams }) => {
		return client
			.get(`${BASE_URL}/cc/sqlmap/v1/sqlIdList?${urlSearchParams}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},
	getSqlContent: sqlId => {
		return client
			.get(`${BASE_URL}/cc/sqlmap/v1/sqlcontent/sqlid/${sqlId}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},
	getSqlLog: sqlId => {
		return client
			.get(`${BASE_URL}/cc/sqlmap/v1/sqllogs/sqlid/${sqlId}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},
	postCompileSql: sqlContent => {
		return client
			.post(`${BASE_URL}/cc/sqlmap/v1/status/1/compile`, sqlContent)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},
	postExeSql: payload => {
		let requestBody = {
			sqlId: payload.sqlId,
			sqlText: payload.StaticSqlText,
			serviceUrl: payload.serviceUrl,
			sqlParameters: payload.sqlParameters,
			serviceProgram: payload.serviceProgram
		};
		// console.log('requestBody', requestBody);
		return client
			.post(`${BASE_URL}/cc/sqlmap/v1/status/1/execute`, requestBody)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},
	postUpdateSql: payload => {
		let requestBody = {
			sqlId: payload.sqlId,
			sqlText: payload.sqlText,
			serviceProgram: payload.serviceProgram
		};

		// console.log('requestBody', requestBody);
		return client
			.post(`${BASE_URL}/cc/sqlmap/v1/status/1/sqlitems/sqlId/${payload.sqlId}/sqlText`, payload)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},
	postDeleteSql: payload => {
		let requestBody = {
			sqlId: payload.sqlId,
			sqlText: payload.sqlText
		};
		return client
			.post(`${BASE_URL}/cc/sqlmap/v1/status/3/sqlitems/sqlId/${payload.sqlId}`, requestBody)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},
	exportXml: () => {
		return client
			.get(`${BASE_URL}/cc/sqlmap/v1/export`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},
	importXml: payload => {
		return client
			.post(`${BASE_URL}/cc/sqlmap/v1/status/1/import`, payload)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	}
};
